
/* eslint-disable no-unused-vars */
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { useEffect, useState } from 'react';
import { List, ListItem, ListItemButton, ListItemText, Stack, styled } from '@mui/material';
import { Mail, Phone } from '@mui/icons-material';
import { Link, useLocation } from 'react-router-dom';

const TitleText = styled(Button)(({ theme }) => ({
    textTransform: "uppercase",
    fontWeight: 600
}));
const pages = [
    {
        label: "Domů",
        href: "/"
    },
    {
        label: "Služby",
        href: "/sluzby"
    },
    {
        label: "Kontakt",
        href: "/kontakt"
    },
];

function ResponsiveAppBar() {
    const [anchorElNav, setAnchorElNav] = useState(null);
    const {pathname} = useLocation()
    const [isTransparent, setIsTransparent] = useState(false);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };


    const handleScroll = () => {
        if (window.scrollY > 100) { 
            setIsTransparent(true);
        } else {
            setIsTransparent(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <AppBar position="fixed" sx={{ backgroundColor: isTransparent ? 'rgba(60, 60, 60, 0.8)' : 'rgba(243, 66, 19, 1)', backdropFilter: isTransparent ? 'blur(10px)' : 'none', transition: 'background-color 0.3s ease, backdrop-filter 0.3s ease'}}>
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Typography
                        variant="h6"
                        noWrap
                        component="a"
                        href="/"
                        sx={{
                            mr: 2,
                            display: { xs: 'none', md: 'flex' },
                            fontWeight: 700,
                            color: 'inherit',
                            textDecoration: 'none',
                        }}
                    >
                        RSrent
                    </Typography>

                    <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                        <IconButton
                            size="large"
                            aria-label="navbar"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{ display: { xs: 'block', md: 'none' } }}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page.label} onClick={handleCloseNavMenu}>
                                    <Link to={page.href}>
                                        <Typography sx={{ textAlign: 'center' }}>{page.label}</Typography>
                                    </Link>
                                </MenuItem>
                            ))}
                        </Menu>
                    </Box>
                    <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                        <List sx={{
                            display: "flex",
                            flexDirection: "row"
                        }}>
                            {pages.map((page) => (
                                <Link to={page.href}>
                                    <ListItemButton selected={pathname === page.href} key={page.label} onClick={handleCloseNavMenu}>
                                        <ListItemText
                                            primaryTypographyProps={{
                                                fontWeight: 600,
                                                textTransform: "uppercase"
                                            }}
                                            primary={page.label}></ListItemText>
                                    </ListItemButton>
                                </Link>
                            ))}
                        </List>
                    </Box>
                    <Box sx={{ flexGrow: 0, alignContent: "center" }}>
                        <Stack flexDirection={"row"} gap={2}>
                            <TitleText href='tel:+420777276064' startIcon={<Phone />} variant="body1" ><Box component="div" sx={{display : { xs : "none", md : "block"}}}>777 276 064</Box></TitleText>
                            <TitleText href='mailto: info@rsrent.cz' startIcon={<Mail />} variant="body1" >info@rsrent.cz</TitleText>
                        </Stack>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
export default ResponsiveAppBar;